export default __webpack_public_path__ + "static/media/filter-white.bddc1caa.svg";